// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__3-TfR","col":"Table_col__AsuRz","fulfillmentStatus":"Table_fulfillmentStatus__1Efqc","emailCol":"Table_emailCol__2fDC3"};